import { Phone, Mail, MapPin } from 'lucide-react';
import SEO from '../../components/SEO';
import { useLanguage } from '../../context/LanguageContext';

const Contact = () => {
  const { t } = useLanguage();

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "mainEntity": {
      "@type": "Organization",
      "name": "La Marmotte Joyeuse",
      "url": "https://marmottejoyeuse.fr",
      "telephone": "06 63 02 42 48",
      "email": "lamarmottejoyeuse@gmail.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "2 Impasse du Garde Champêtre",
        "addressLocality": "La Grave",
        "postalCode": "05320",
        "addressCountry": "FR"
      }
    }
  };

  return (
    <>
      <SEO
        title={t('seo.contact.title')}
        description={t('seo.contact.description')}
        keywords="contact la grave, réservation hébergement, téléphone marmotte joyeuse, email contact, adresse la grave"
        url="/contact"
        structuredData={structuredData}
      />
      <div className="container mx-auto px-4 pt-28 pb-16 min-h-screen">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h1 className="text-5xl font-extrabold mb-4 text-primary">
              {t('contact.title')}
            </h1>
            <p className="text-xl max-w-3xl mx-auto text-base-content/80 mb-8">
              {t('contact.subtitle')}
            </p>
            <div className="h-1 w-32 bg-primary mx-auto"></div>
          </div>

          <div className="space-y-8 max-w-2xl mx-auto">
            <div>
              <h2 className="text-3xl font-bold mb-6">{t('contact.coordTitle')}</h2>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <Phone className="w-6 h-6 text-primary mt-1" />
                  <div>
                    <h3 className="font-semibold text-lg">{t('contact.phone')}</h3>
                    <p className="text-base-content/80">06 63 02 42 48</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <Mail className="w-6 h-6 text-primary mt-1" />
                  <div>
                    <h3 className="font-semibold text-lg">{t('contact.email')}</h3>
                    <p className="text-base-content/80">lamarmottejoyeuse@gmail.com</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <MapPin className="w-6 h-6 text-primary mt-1" />
                  <div>
                    <h3 className="font-semibold text-lg">{t('contact.address')}</h3>
                    <p className="text-base-content/80">
                      2 Impasse du Garde Champêtre<br />
                      05320 La Grave, France
                    </p>
                  </div>
                </div>

              </div>
            </div>

            <div className="bg-base-200 rounded-xl p-4">
              <h3 className="text-xl font-bold mb-4">{t('contact.mapTitle')}</h3>
              <div className="w-full h-64 rounded-lg overflow-hidden">
                <iframe
                  title="Google Maps - La Marmotte Joyeuse"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2834.175167119725!2d6.305305015731621!3d45.04473905830461!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4789e446d3d7d0bb%3A0x7f7c77a5469f69!2s2%20Imp.%20du%20Garde%20Champ%C3%AAtre%2C%2005320%20La%20Grave!5e0!3m2!1sfr!2sfr!4v1690000000000!5m2!1sfr!2sfr"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
